import { Card, CardContent } from '@/app/common/components/Card'
import MultiQueryPageLoader from '@/app/common/components/MultiQueryPageLoader'
import { WarningIcon } from '@/app/common/icons/support'
import { academicTermsQueries } from '@/queries/academic_terms/queries'
import { ProgramQueries } from '@/queries/program/queries'
import { selectSelectedProgram } from '@/storage/programs/slice'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getAcademicTermsByTermType, getSelectedProgramYear } from '../utils'
import AcademicTermsView from './_components/academic-terms-view'

export default function ViewAcademicTermsPage() {
  const selectedProgramYear = useSelector(selectSelectedProgram).id
  const programAcademicTermsQuery = useQuery(
    academicTermsQueries.getProgramAcademicTerms(selectedProgramYear)
  )

  const globalAcademicTermsQuery = useQuery(
    academicTermsQueries.getGlobalAcademicTerms()
  )

  const programDetailsQuery = useQuery(ProgramQueries.FetchGlobalPrograms())

  return (
    <MultiQueryPageLoader
      queries={
        [
          programAcademicTermsQuery,
          globalAcademicTermsQuery,
          programDetailsQuery,
        ] as const
      }
    >
      {([academicTerms, globalAcademicTerms, programDetails]) => {
        const selectedProgram = getSelectedProgramYear(
          programDetails,
          selectedProgramYear
        )

        if (!selectedProgram) {
          return (
            <Card>
              <CardContent>
                <WarningIcon className="text-3xl text-primary-500" />
                <h3 className="text-2xl font-medium text-gray-800">
                  Selected program year not found
                </h3>
                <p>Please contact support to get help with this issue.</p>
              </CardContent>
            </Card>
          )
        }

        const selectedAcademicTerms = getAcademicTermsByTermType(
          academicTerms,
          selectedProgram
        )

        return (
          <AcademicTermsView
            programAcademicTerms={selectedAcademicTerms}
            globalAcademicTerms={globalAcademicTerms}
            programSettings={selectedProgram}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}
